export default __webpack_public_path__ + "static/media/polaroid8.e483298d.svg";